<template>
    <v-container fluid>
        <v-row>
            <!-- Master: Macro Aree -->
            <v-col cols="12" md="5">
                <v-card>
                    <v-card-title class="d-flex align-center">
                        Macro aree
                        <v-spacer />
                        <v-btn icon variant="text" size="small" @click="apriDialogMacroArea(null)">
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-list>
                        <v-list-item v-for="ma in macroAree" :key="ma.id" :title="ma.nome"
                            :subtitle="ma.numeroReparti + ' reparti'" :active="macroAreaSelezionata === ma.id"
                            color="primary" @click="selezionaMacroArea(ma.id)">
                            <template #append>
                                <v-btn icon variant="text" size="small" @click.stop="apriDialogMacroArea(ma)">
                                    <v-icon size="small">mdi-pencil</v-icon>
                                </v-btn>
                                <v-btn icon variant="text" size="small" color="error"
                                    @click.stop="eliminaMacroArea(ma)">
                                    <v-icon size="small">mdi-delete</v-icon>
                                </v-btn>
                            </template>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-col>

            <!-- Detail: Reparti della macro area selezionata -->
            <v-col cols="12" md="7">
                <v-card>
                    <v-card-title class="d-flex align-center">
                        Reparti
                        <v-spacer />
                        <v-btn icon variant="text" size="small" :disabled="!macroAreaSelezionata"
                            @click="apriDialogReparto(null)">
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-card-text v-if="!macroAreaSelezionata" class="text-medium-emphasis">
                        Seleziona una macro area per vederne i reparti.
                    </v-card-text>
                    <v-list v-else>
                        <v-list-item v-for="r in reparti" :key="r.id" :title="r.nome"
                            :subtitle="r.numeroMacchine + ' macchine'">
                            <template #append>
                                <v-btn icon variant="text" size="small" @click="apriDialogReparto(r)">
                                    <v-icon size="small">mdi-pencil</v-icon>
                                </v-btn>
                                <v-btn icon variant="text" size="small" color="error" @click="eliminaReparto(r)">
                                    <v-icon size="small">mdi-delete</v-icon>
                                </v-btn>
                            </template>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-col>
        </v-row>

        <!-- Dialog Macro Area -->
        <v-dialog v-model="dialogMacroArea" max-width="420">
            <v-card>
                <v-card-title>{{ formMacroArea.id ? 'Modifica macro area' : 'Nuova macro area' }}</v-card-title>
                <v-card-text>
                    <v-form ref="formMacroAreaRef">
                        <v-text-field v-model="formMacroArea.nome" label="Nome" :rules="[v => !!v || 'Obbligatorio']" />
                        <v-textarea v-model="formMacroArea.descrizione" label="Descrizione" rows="2" />
                        <v-text-field v-model.number="formMacroArea.progOrder" type="number" label="Ordine" />
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn variant="text" @click="dialogMacroArea = false">Annulla</v-btn>
                    <v-btn color="primary" @click="salvaMacroArea">Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog Reparto -->
        <v-dialog v-model="dialogReparto" max-width="420">
            <v-card>
                <v-card-title>{{ formReparto.id ? 'Modifica reparto' : 'Nuovo reparto' }}</v-card-title>
                <v-card-text>
                    <v-form ref="formRepartoRef">
                        <v-text-field v-model="formReparto.nome" label="Nome" :rules="[v => !!v || 'Obbligatorio']" />
                        <v-textarea v-model="formReparto.descrizione" label="Descrizione" rows="2" />
                        <v-text-field v-model.number="formReparto.progOrder" type="number" label="Ordine" />
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn variant="text" @click="dialogReparto = false">Annulla</v-btn>
                    <v-btn color="primary" @click="salvaReparto">Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
export default {
    name: "ConfigurazionePage",

    data() {
        return {
            macroAreaSelezionata: null,
            dialogMacroArea: false,
            dialogReparto: false,
            formMacroArea: { id: null, nome: "", descrizione: "", progOrder: 0 },
            formReparto: { id: null, macroAreaId: null, nome: "", descrizione: "", progOrder: 0 },
        };
    },

    computed: {
        macroAree() {
            return this.$store.getters["configurazione/macroAree"];
        },
        reparti() {
            return this.$store.getters["configurazione/reparti"];
        },
    },

    mounted() {
        this.$store.dispatch("configurazione/caricaMacroAree");
    },

    methods: {
        selezionaMacroArea(id) {
            this.macroAreaSelezionata = id;
            this.$store.dispatch("configurazione/caricaReparti", id);
        },

        apriDialogMacroArea(item) {
            this.formMacroArea = item
                ? { id: item.id, nome: item.nome, descrizione: item.descrizione, progOrder: item.progOrder }
                : { id: null, nome: "", descrizione: "", progOrder: 0 };
            this.dialogMacroArea = true;
        },

        async salvaMacroArea() {
            if (!this.$refs.formMacroAreaRef.validate()) return;
            try {
                const { id, ...dati } = this.formMacroArea;
                await this.$store.dispatch("configurazione/salvaMacroArea", { id, dati });
                this.dialogMacroArea = false;
            } catch (error) {
                console.log(error);
            }
        },

        async eliminaMacroArea(item) {
            try {
                await this.$store.dispatch("configurazione/eliminaMacroArea", item.id);
                if (this.macroAreaSelezionata === item.id) this.macroAreaSelezionata = null;
            } catch (error) {
                console.log(error);
                // NOTA: il backend rifiuta l'eliminazione se ci sono reparti attivi;
                // il messaggio d'errore va mostrato con il componente toast (da collegare).
            }
        },

        apriDialogReparto(item) {
            this.formReparto = item
                ? {
                    id: item.id,
                    macroAreaId: item.macroAreaId,
                    nome: item.nome,
                    descrizione: item.descrizione,
                    progOrder: item.progOrder,
                }
                : { id: null, macroAreaId: this.macroAreaSelezionata, nome: "", descrizione: "", progOrder: 0 };
            this.dialogReparto = true;
        },

        async salvaReparto() {
            if (!this.$refs.formRepartoRef.validate()) return;
            try {
                const { id, ...dati } = this.formReparto;
                await this.$store.dispatch("configurazione/salvaReparto", {
                    id,
                    dati,
                    macroAreaId: this.macroAreaSelezionata,
                });
                this.dialogReparto = false;
            } catch (error) {
                console.log(error);
            }
        },

        async eliminaReparto(item) {
            try {
                await this.$store.dispatch("configurazione/eliminaReparto", {
                    id: item.id,
                    macroAreaId: this.macroAreaSelezionata,
                });
            } catch (error) {
                console.log(error);
            }
        },
    },
};
</script>